import React, { useState } from "react";
import { BadgeDollarSign } from "lucide-react";
import { PageHeader } from "../../../components/PageHeader";
import { SpendSection } from "./SpendSection";
import VideoCostTab from "./VideoCostTab";
import MarginReport from "../margin/MarginReport";

const TABS = [["margin", "Realisasi Margin"], ["llm", "Pemakaian LLM (lama)"], ["video", "Video Avatar (lama)"]];

export default function PlatformAiCost() {
  const [tab, setTab] = useState("margin");
  return (
    <div data-testid="ai-cost-page">
      <PageHeader icon={BadgeDollarSign} title="Biaya AI" description="Biaya provider AI riil vs kredit terpakai — realisasi margin per provider, model & fitur (USD)." />
      <div className="tabs mt-5">{TABS.map(([k, l]) => <button key={k} onClick={() => setTab(k)} className={`tab ${tab === k ? "tab-active" : ""}`} data-testid={`ai-cost-tab-${k}`}>{l}</button>)}</div>
      <div className="mt-6">{tab === "margin" ? <MarginReport /> : tab === "llm" ? <SpendSection /> : <VideoCostTab />}</div>
    </div>
  );
}
